import React, { useMemo, useState } from "react";
import { HelpCircle, MessageCircle, Phone, Ban } from "lucide-react";
import { getRole } from "../../utils/authService";
import { Tabs } from "../common/ui.jsx";
import InstallGuide from "./InstallGuide.jsx";
import { SUPPORT_EMAIL, SUPPORT_WHATSAPP } from "../../utils/supportContacts";
import "./guide.css";

function UsagePanel() {
  return (
    <div className="gp-doc">
      <p className="gp-doc-lead">Day-to-day usage articles are being written — check back soon.</p>
      <p>In the meantime, most pages have inline guidance where you need it, and the <strong>VisuN AI</strong> chat can answer specific questions about your data.</p>
    </div>
  );
}

function FaqPanel() {
  return (
    <div className="gp-doc">
      <p className="gp-doc-lead">Frequently asked questions are being compiled — check back soon.</p>
      <p>For anything urgent, use the Support tab (tenant admins) or the VisuN AI chat.</p>
    </div>
  );
}

function SupportPanel() {
  return (
    <div className="gp-doc gp-support">
      <p className="gp-doc-lead">Reach the VisuN team directly.</p>
      <div className="gp-support-grid">
        <div className="gp-support-card gp-support-disabled">
          <Ban size={18} />
          <div className="gp-support-title">Feedback</div>
          <div className="gp-support-desc">Coming soon</div>
        </div>
        <a className="gp-support-card" href={`https://wa.me/${SUPPORT_WHATSAPP}`} target="_blank" rel="noopener noreferrer">
          <MessageCircle size={18} />
          <div className="gp-support-title">Chat</div>
          <div className="gp-support-desc">WhatsApp support</div>
        </a>
        <a className="gp-support-card" href={`mailto:${SUPPORT_EMAIL}`}>
          <Phone size={18} />
          <div className="gp-support-title">Call / Email</div>
          <div className="gp-support-desc">{SUPPORT_EMAIL}</div>
        </a>
      </div>
    </div>
  );
}

export default function GuidePage() {
  const role = useMemo(() => getRole(), []);
  const isTenantAdmin = role === "client";

  const tabs = useMemo(() => {
    const base = [
      { id: "installation", label: "Installation", Component: InstallGuide },
      { id: "usage", label: "Usage", Component: UsagePanel },
      { id: "faq", label: "FAQ", Component: FaqPanel },
    ];
    // Support is tenant-admin only, per spec.
    if (isTenantAdmin) base.push({ id: "support", label: "Support", Component: SupportPanel });
    return base;
  }, [isTenantAdmin]);

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActivePanel = tabs.find((t) => t.id === activeTab)?.Component || tabs[0].Component;

  return (
    <div className="gp-root">
      <header className="gp-header">
        <h1 className="gp-title">Guide</h1>
        <p className="gp-subtitle">Everything you need to set up and use VisuN AI.</p>
      </header>
      <Tabs tabs={tabs} activeId={activeTab} onChange={setActiveTab} />
      <ActivePanel />
    </div>
  );
}
